
const initState = () => ({
  loading: false,
  frontendId: 2
})

export const state = initState

export const getters = {
  loading: (state) => state.loading,
}

export const mutations = {
  setLoading(state, {loading}) {
    state.loading = loading
  },
}
export const actions = {
  async nuxtServerInit({dispatch, state}) {
    await dispatch('common/formatter/fetchFormatSettings')
    if (state.auth.loggedIn) {
      await dispatch('settings/fetchFields')
      await dispatch('admin-settings/modules/fetchModules')
      await  dispatch('users/getAllUsers')
    }
  },
}
